import React from "react";
import header from "./header.css";

export default function Header(){
    return(    
    <div className="header">
        <h1 className="header-h1">DiceGame</h1>
        <h2 className="header-h2">🚩GAME FOR ALL!!!🚩</h2>
    </div>
    )
}